import gql from 'graphql-tag';

export const CCA_SETTINGS_QUERY = gql`
  query CcaSettingsQuery($id: ID!) {
    campaign(id: $id) {
      id
      publisherId
      defaultObjective
      ccaEnabled
      pageLockedArticlesEnabled
      ccaSettings {
        id
        automaticCreativeCreation
        automaticApprovalRequest
        automaticApprovalRequestType
        postTextHashtagsEnabled
        postTextHashtags
        descriptionMode
        customDescription
        maxCreativesPerArticle
        leadgenFormExternalId
        leadgenCreativeCallToAction
        enableLeadgenFormNamePrefix
        leadgenFormNamePrefix
        enableLeadgenFormNameSuffix
        leadgenFormNameSuffix
        leadgenFormQueryParameters {
          key
          value
        }
      }
      articleCategories {
        id
        name
        description
        isDefault
        createdAt
      }
      campaignPostMaloneSavedTemplates {
        id
        campaignId
        ccaTemplateType
        postMaloneSavedTemplateId
        selectedAt
        categoryIds
        postMaloneSavedTemplate {
          id
          externalId
          publisherId
          name
          description
          templateType
          selectable
          inputs {
            name
            type
          }
          outputs {
            name
            contentType
          }
          fetchedAt
        }
      }
      publisherPostMaloneSavedTemplates {
        id
        ccaTemplateType
        externalId
        publisherId
        name
        description
        templateType
        selectable
        inputs {
          name
          type
        }
        outputs {
          name
          contentType
        }
        fetchedAt
      }
    }
  }
`;
